// extracted by mini-css-extract-plugin
export var boldText = "_5t-4";
export var checkboxContainer = "_5t-6";
export var closeIcon = "_5t-i";
export var container = "_5t-0";
export var drawer = "_5t-8";
export var drawerContent = "_5t-9";
export var extraSmallText = "_5t-5";
export var fulfillmentGroupTable = "_5t-e";
export var largeText = "_5t-3";
export var loadingSpinnerContainer = "_5t-j";
export var mediumText = "_5t-2";
export var narrow = "_5t-f";
export var notificationLink = "_5t-l";
export var packageCheckIconContainer = "_5t-7";
export var slideoutHeaderActions = "_5t-g";
export var slideoutHeaderActionsShifted = "_5t-h";
export var slideoutHeaderContainer = "_5t-a";
export var slideoutModal = "_5t-c";
export var stickyHeaderWrapper = "_5t-b";
export var table = "_5t-k";
export var tableContainer = "_5t-d";
export var tertiaryText = "_5t-1";